export enum Countries {
  USA = 'USA',
  CANADA = 'Canada'
}
